import { useUpc } from '@nuxt-common/media-card-large/app/composables/useUpc';
import { useTraits } from '@nuxt-common/media-card-large/app/composables/useTraits';
import { useProduct } from '~/modules/product/composables/useProduct';
import useTypeBySelectedColor from '~/composables/useTypeBySelectedColor';

// Utility function to get UPC data with a fallback mechanism
export function getUpcDataWithFallback(upcMap, baseId) {
  // First, check if the baseId is directly available in upcMap
  let upcData = upcMap?.[baseId];

  // If not found, try appending "_0" to the baseId as a fallback
  if (!upcData) {
    const fallbackId = `${baseId}_0`;
    upcData = upcMap?.[fallbackId];
  }

  // Return the found data or undefined if neither key exists
  return upcData;
}

/**
 * @param {Product} product
 * @param {number} upcId
 * @returns {{ planDescription: object, allPlans: any[]}}
 */
export function getPlansInfoFromProduct(product, upcId) {
  if (!product || !upcId) return { planDescription: {}, allPlans: [] };
  const upcInfo = product?.relationships?.upcs?.[upcId];
  const planDescription = upcInfo?.planDescription || {};
  const allPlans = upcInfo?.protectionPlans || [];
  return {
    planDescription,
    allPlans,
  };
}

export function useProtectionPlanBigTicketDescription() {
  const { productData, productId } = useProduct();
  const { selectedColorId } = useTraits(productId);
  const type = useTypeBySelectedColor(selectedColorId?.value);
  const id = type ? `${selectedColorId?.value}_${type}` : `${selectedColorId?.value}`;
  const { upcData } = useUpc(productId);
  const { upcMap } = upcData?.value || {};

  // Use the utility function to get the UPC data with a fallback
  const _id = getUpcDataWithFallback(upcMap, id);
  return getPlansInfoFromProduct(productData, _id);
}
